import React from "react";
import SocialCallback from "./social-callback";

export const FacebookCallback: React.FC = () => {
  return <SocialCallback provider="facebook" />;
};

export default FacebookCallback;
